import React from 'react';

const AlbumUsb = () => {
    return (
      <React.Fragment>
        {/* Album / USB */}
        <div className="btn__base r2c17">
          <div className="btn">
            <div className="numbox">
              <div className="num">⦿</div>
              <div className="btm">COM</div>
            </div>
          </div>
        </div>
        {/* Album / USB */}
      </React.Fragment>
    );
  };

export default AlbumUsb;